import { HeadSEO } from "@/components/SEO/HeadSEO";
import AccordionContactContainer from "@/components/AccordionContact/accordionContactContainer";
import * as StyledLayout from "@/layouts/Styled.Layout";
import * as StyledTypography from "@/styles/Styled.Typography";
import * as StyledButtons from "@/styles/Styled.Buttons";
import * as StyledContact from "./Styled.Contact";
import ContactForm from "@/components/ContactForm";

export default function Contact() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Stanley Yeo",
    url: "https://stanleyyeo.com",
  };
  return (
    <>
      <HeadSEO
        siteTitle="Contact"
        siteDescription="Get in touch with Stanley Yeo for freelance web design, WordPress development, or brand identity projects in Singapore."
        structuredData={structuredData}
      />
      <StyledTypography.ParadoxSubtitle as="h2" data-animate="fade-up">
        Amazing partnerships starts here.
      </StyledTypography.ParadoxSubtitle>
      <StyledLayout.Grid>
        <StyledLayout.GridItem>
          <p data-animate="fade-up">
            Thanks for reaching out. Courage is about taking the first step even
            when you don’t see the whole picture. I’m stoked you did that. It
            takes boldness to invest in your brand and online presence. But
            don't worry if you are still on the fence. I'm skilled at nudging
            people to the other side.
          </p>
          <p data-animate="fade-up">
            As an independent freelance web designer in Singapore, I help small
            businesses launch WordPress websites and craft brand identity
            design. Still reading? That’s all the proof you need that it’s
            working.
          </p>
          <p data-animate="fade-up">
            I trust you can tell when you are being bold and when you are flying
            blind, because most people can't tell the difference between taking
            a calculated risk and just being reckless.
          </p>
          <p data-animate="fade-up">
            The majority of them are building their entire business solely on
            social media. Why do they operate their business on borrowed land?
            Are they immune to social consequences? Did they misunderstand a
            lack of awareness for bravery?
          </p>
          <p data-animate="fade-up">
            Consider how quickly your life will fall apart the moment the
            algorithm turns or the platform pulls the plug.
          </p>
          <p data-animate="fade-up">
            That’s why I recommend anyone who lands here to build their brand on
            the ground they own.
          </p>
          <StyledTypography.Ul data-animate="fade-up">
            <li data-animate="fade-up">
              Own your site. Turn traffic into action.
            </li>
            <li data-animate="fade-up">
              Own your audience. Grow your reach without middlemen.
            </li>
            <li data-animate="fade-up">
              Own your content. Control the message, the medium, and the future.
            </li>
          </StyledTypography.Ul>
        </StyledLayout.GridItem>
      </StyledLayout.Grid>

      <StyledContact.GridBsCardsWrapper>
        <StyledContact.GridItemBsCard>
          <StyledLayout.Cards data-animate="fade-up">
            <StyledTypography.ModulePin as="h3" data-animate="fade-up">
              The Foundation Build
            </StyledTypography.ModulePin>
            <StyledContact.BsContentWrapper>
              <h4 data-animate="fade-up">Brand & Web Launch</h4>
              <p data-animate="fade-up">(From $9,000)</p>
              <StyledContact.BsDescription data-animate="fade-up">
                Handover in 30 days.
              </StyledContact.BsDescription>
              <hr data-animate="fade-up" />
              <p data-animate="fade-up">One-time professional setup.</p>
              <span data-animate="fade-up">
                A complete identity and high-performance site built with Bedrock
                for security and speed. Best for new ventures needing a
                world-class start.
              </span>
              <StyledButtons.PrimaryButton
                as="a"
                onClick={(e) => {
                  e.preventDefault();

                  // 1. Update URL (mostly for visual/refresh purposes)
                  window.history.pushState(
                    null,
                    null,
                    `#contactForm?plan=foundation`,
                  );

                  // 2. Smooth Scroll
                  document
                    .getElementById("contactForm")
                    ?.scrollIntoView({ behavior: "smooth" });

                  // 3. Dispatch Custom Event
                  const event = new CustomEvent("planSelect", {
                    detail: "foundation",
                  });
                  window.dispatchEvent(event);
                }}
                rel="noopener noreferrer"
                data-animate="fade-up"
              >
                Get Started
              </StyledButtons.PrimaryButton>
            </StyledContact.BsContentWrapper>
          </StyledLayout.Cards>
        </StyledContact.GridItemBsCard>
        <StyledContact.GridItemBsCard>
          <StyledLayout.Cards data-animate="fade-up">
            <StyledTypography.ModulePin as="h3" data-animate="fade-up">
              The Growth Partnership
            </StyledTypography.ModulePin>
            <StyledContact.BsContentWrapper>
              <h4 data-animate="fade-up">Launch & Lead</h4>
              <p data-animate="fade-up">($6,000 + $500/mo)</p>
              <StyledContact.BsDescription data-animate="fade-up">
                12-Month Success Journey
              </StyledContact.BsDescription>
              <hr data-animate="fade-up" />
              <h5 data-animate="fade-up">
                <span>Our most popular path.</span>
              </h5>
              <span data-animate="fade-up">
                Lower your upfront cost. We build your site and stay on as your
                technical partner for security, updates, and monthly design
                tweaks.
              </span>
              <StyledButtons.PrimaryButton
                as="a"
                onClick={(e) => {
                  e.preventDefault();

                  // 1. Update URL (mostly for visual/refresh purposes)
                  window.history.pushState(
                    null,
                    null,
                    `#contactForm?plan=partnership`,
                  );

                  // 2. Smooth Scroll
                  document
                    .getElementById("contactForm")
                    ?.scrollIntoView({ behavior: "smooth" });

                  // 3. Dispatch Custom Event
                  const event = new CustomEvent("planSelect", {
                    detail: "partnership",
                  });
                  window.dispatchEvent(event);
                }}
                rel="noopener noreferrer"
                data-animate="fade-up"
              >
                Apply Partnership
              </StyledButtons.PrimaryButton>
            </StyledContact.BsContentWrapper>
          </StyledLayout.Cards>
        </StyledContact.GridItemBsCard>
        <StyledContact.GridItemBsCard>
          <StyledLayout.Cards data-animate="fade-up">
            <StyledTypography.ModulePin as="h3" data-animate="fade-up">
              The Fractional Partner
            </StyledTypography.ModulePin>
            <StyledContact.BsContentWrapper>
              <h4 data-animate="fade-up">Design Partner</h4>
              <p data-animate="fade-up">($3,000/mo)</p>
              <StyledContact.BsDescription data-animate="fade-up">
                6-Month Active Partnership
              </StyledContact.BsDescription>
              <hr data-animate="fade-up" />
              <p data-animate="fade-up">Your on-demand design team.</p>
              <span data-animate="fade-up">
                Unlimited design and web support for established businesses. One
                active task at a time. No long-term hiring costs.
              </span>
              <StyledButtons.PrimaryButton
                as="a"
                onClick={(e) => {
                  e.preventDefault();

                  // 1. Update URL (mostly for visual/refresh purposes)
                  window.history.pushState(
                    null,
                    null,
                    `#contactForm?plan=fractional`,
                  );

                  // 2. Smooth Scroll
                  document
                    .getElementById("contactForm")
                    ?.scrollIntoView({ behavior: "smooth" });

                  // 3. Dispatch Custom Event
                  const event = new CustomEvent("planSelect", {
                    detail: "fractional",
                  });
                  window.dispatchEvent(event);
                }}
                rel="noopener noreferrer"
                data-animate="fade-up"
              >
                Subscribe Now
              </StyledButtons.PrimaryButton>
            </StyledContact.BsContentWrapper>
          </StyledLayout.Cards>
        </StyledContact.GridItemBsCard>
      </StyledContact.GridBsCardsWrapper>

      <StyledLayout.Grid>
        <StyledLayout.GridItem>
          <p data-animate="fade-up">
            To ensure a seamless process for us to get acquainted, I think it
            helps to lay down a few ground rules so we won’t be caught totally
            off guard in an awkward situation. I say this from experience so we
            won’t waste our precious time beating about the bush.
          </p>
          <p data-animate="fade-up">
            This is a good time to refer to the following guidelines because I
            anticipate your curiosity.
          </p>
        </StyledLayout.GridItem>
        <StyledLayout.GridItem>
          <AccordionContactContainer />
        </StyledLayout.GridItem>
        {/* Contact Form Section */}
        <StyledLayout.GridItem data-animate="fade-up">
          <ContactForm />
        </StyledLayout.GridItem>
      </StyledLayout.Grid>
    </>
  );
}
